import { render, staticRenderFns } from "./QuickAddVendorContractModal.vue?vue&type=template&id=72d3f07c"
import script from "./QuickAddVendorContractModal.vue?vue&type=script&lang=ts"
export * from "./QuickAddVendorContractModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports